import { useTranslation } from 'react-i18next';
import { ListPageLayout } from '@/components/templates';
import { ShopListContainer } from '@/features/shops/containers/shop-list-container';

export default function ShopsPage() {
  const { t } = useTranslation();

  return (
    <ListPageLayout title={t('shops.title')}>
      <ShopListContainer />
    </ListPageLayout>
  );
}
